export const ROUTES = {
    TRANING_MANAGEMENT: 'training-management',
}